import Reflux from "reflux";

var ExportActions = Reflux.createActions({
  exportDesign: {},
  exportDesignBegin: {},
});

export default ExportActions;
